/* eslint-disable func-names */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { useRecoilValue } from 'recoil';
import Steps from './Steps';
import PjInfo from './PjInfo';
import RadarChart from '../Shared/RadarChart';
import { projectsDataAtom, openProjectNameAtom } from '../Atoms';

const useStyles = makeStyles({
  page2Draw: {
    zIndex: 1300,
  },
  item: {
    marginTop: '10vh',
  },
  client: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  dot: {
    width: '16px',
    height: '16px',
    borderRadius: '50px',
    margin: '8px',
  },
  chart: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const InfoSidebar = function () {
  const classes = useStyles();
  const intl = useIntl();
  const projectsData = useRecoilValue(projectsDataAtom);
  const [currentProjectData, setCurrentProjectData] = useState([]);
  const openProjectName = useRecoilValue(openProjectNameAtom);

  useEffect(() => {
    setCurrentProjectData(projectsData.find((x) => x.Name === openProjectName && x.isCurrent === 1));
  }, [projectsData]);

  const logoObj = currentProjectData?.LOGO;
  return (
    <Container className={classes.item}>
      <Container className={classes.client} sx={{ mb: 1.5, mt: 1 }}>
        <Avatar
          sx={{ width: 120, height: 120 }}
          //sx={{ bgcolor: '#00796b' }}
          aria-label="recipe"
          src={`data:${logoObj?.contentType};base64,${logoObj?.base64}`}
          variant="square"
        />
        <Typography variant="subtitle2">
          {currentProjectData?.Client} {currentProjectData?.RagSociale}
        </Typography>
        <Typography variant="subtitle1">{openProjectName}</Typography>
      </Container>
      <PjInfo projectName={openProjectName} />
      <Divider />
      <Typography variant="subtitle2" sx={{ mt: 1 }}>
        {intl.messages.CONTACTPERSON?.toUpperCase()}
      </Typography>
      <List dense>
        <ListItem style={{ padding: 0 }}>
          <ListItemAvatar>
            <Avatar sx={{ width: 30, height: 30 }} />
          </ListItemAvatar>
          <ListItemText primary={currentProjectData?.Pm} secondary={intl.messages.PROJECTMANAGER} />
        </ListItem>
      </List>
      <Typography variant="subtitle2">{intl.messages.DESIGNREVIEW}</Typography>
      <Container>
        <Steps projectName={openProjectName} />
      </Container>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Container className={classes.chart}>
        <RadarChart projectName={openProjectName} />
      </Container>
    </Container>
  );
};

export default InfoSidebar;
